import { Button, Spinner } from '@material-tailwind/react'

export const AccessButtons = ({ handleSubmit, loading, isOfficePreselected, officeId }) => (
  <>
    <div className="flex flex-col sm:flex-row sm:gap-2 gap-1">
      <Button
        onClick={(e) => handleSubmit(e, 'entry')}
        fullWidth
        disabled={loading || (!isOfficePreselected && (!officeId || officeId === 'all'))}
        color="green"
        className="flex items-center justify-center gap-2"
      >
        {loading ? <Spinner className="h-4 w-4" /> : 'Registrar Entrada'}
      </Button>

      <Button
        onClick={(e) => handleSubmit(e, 'exit')}
        fullWidth
        disabled={loading || (!isOfficePreselected && (!officeId || officeId === 'all'))}
        color="blue"
        className="flex items-center justify-center gap-2"
      >
        {loading ? <Spinner className="h-4 w-4" /> : 'Registrar Salida'}
      </Button>
    </div>

    <Button
      onClick={(e) => handleSubmit(e, 'query')}
      fullWidth
      disabled={loading}
      className="flex items-center justify-center gap-2 bg-gray-200 text-gray-700 hover:bg-gray-300"
    >
      {loading ? <Spinner className="h-4 w-4" /> : (
        <>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 1C8.676 1 6 3.676 6 7v1H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2h-1V7c0-3.324-2.676-6-6-6zm0 2c2.276 0 4 1.724 4 4v1H8V7c0-2.276 1.724-4 4-4zM5 10h14v10H5V10zm7 3a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1z" />
          </svg>
          Consulta
        </>
      )}
    </Button>
  </>
)
